import { COLORS } from '@btime/constants'
import { ClipLoader } from 'react-spinners'
import { MESSAGER_TYPES, useMessagerActions, useMessagerState } from '@btime/react-messager'
import React from 'react'

import { Notification, NotificationsWrapper } from './Notification'

const { SUCCESS, INFO, ERROR, WARN, LOADING } = MESSAGER_TYPES

const iconMapByType = {
  [INFO]: { iconColor: COLORS.blue, icon: 'BsInfoSquare' },
  [SUCCESS]: { iconColor: COLORS.green, icon: 'BsCheckCircle' },
  [ERROR]: { color: COLORS.red, icon: 'BsXOctagon' },
  [WARN]: { iconColor: COLORS.yellow, icon: 'BsExclamationOctagon' },
  [LOADING]: { iconColor: COLORS.dark3, iconElem: <ClipLoader size={20} color={COLORS.light3} /> }
}

const getNotificationProps = notification => ({
  ...notification,
  ...(iconMapByType[notification.type || INFO] || iconMapByType[INFO])
})

// TODO: Move to react-messagers package after components has its own package
const ListNotifications = () => {
  const { notifications } = useMessagerState()
  const { removeNotification } = useMessagerActions()

  return (
    <NotificationsWrapper>
      {notifications.map(item => {
        const notificationProps = getNotificationProps(item)
        return (
          <Notification
            key={item.id}
            {...notificationProps}
            onClose={() => {
              notificationProps?.onClose && notificationProps.onClose()
              removeNotification(item.id)
            }}
          />
        )
      })}
    </NotificationsWrapper>
  )
}

export default ListNotifications
